import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.MODULE_POLI_SET_LOADER,
        payload: data
    }
};

export const getDataPoli =  (value) => {
    return ({
        type: types.MODULE_POLI_DATA_GET,
        value
    })
}

export const initFormPoli = (value) => {
    return ({
        type: types.MODULE_POLI_INIT_FORM_POLI,
        value
    })
}

export const getMasterData =  () => {
    return ({
        type: types.MODULE_POLI_MASTER_DATA,
    })
}

export const handleStateForm =  (property, value) => {
    return ({
        type: types.MODULE_POLI_HANDLE_STATE_FORM,
        property,
        value
    })
}

export const postForm = (history, value) => {
    return ({
        type: types.MODULE_POLI_SUBMIT_FORM,
        history,
        value
    })
}







